export default "__VITE_ASSET__79477e6d__"